<template>
  <div>
    
    <b-row>
      <b-col sm="12" lg="8" class="row-align-left align-middle">
        <span>
          Have you ever been diagnosed with diabetes by a health care
          professional?
        </span>
      </b-col>
      <b-col sm="4">
        <b-row>
          <b-col md="6" >
            <label class="float-left" for="rd1">
              <input
                type="radio"
                v-model="$v.diagnosedDiabetes.$model"
                class="option-input radio"
                :class="{ 'invalid-radio-button': diabetesState }"
                name="rd1"
                :value="true"
              >
              Yes
            </label>
          </b-col>
          <b-col class="float-left" md="6" >
            <label class="float-left" for>
              <input
                type="radio"
                v-model="$v.diagnosedDiabetes.$model"
                class="option-input radio"
                :class="{ 'invalid-radio-button': diabetesState }"
                name="rd1"
                :value="false"
              >
              No
            </label>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col sm="6" lg="8" class="row-align-left">
        <label>What is your age? Please enter the exact age:</label>
      </b-col>
      <b-col sm="4" lg="2">
        <b-form-input id="txtAge" type="number" :state="ageState" min="1" max="120" size="lg" v-model="$v.age.$model"></b-form-input>
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col sm="12" lg="6" class="row-align-left">
        <label>Are you a man or a woman?</label>
      </b-col>
      <b-col sm="6">
        <b-row>
          <b-col md="4" >
            <label class="float-left" for>
              <input
                type="radio"
                v-model="$v.gender.$model"
                class="option-input radio"
                :class="{ 'invalid-radio-button': genderState }"
                name="rd2"
                :value="'M'"
              >
              Man
            </label>
          </b-col>
          <b-col md="4" >
            <label class="float-left" for>
              <input
                type="radio"
                v-model="$v.gender.$model"
                class="option-input radio"
                :class="{ 'invalid-radio-button': genderState }"
                name="rd2"
                :value="'F'"
              >
              Woman
            </label>
          </b-col>
          <b-col md="4" >
            <label class="float-left" for>
              <input
                type="radio"
                v-model="$v.gender.$model"
                class="option-input radio"
                :class="{ 'invalid-radio-button': genderState }"
                name="rd2"
                :value="'X'"
              >
              Other
            </label>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <hr>
    <b-row v-show="gender != null && gender == 'F'">
      <b-col sm="8" class="row-align-left">

        <label class="row-align-left">
          Have you ever been diagnosed with gestational diabetes?
        </label>
      </b-col>
      <b-col sm="4">
        <b-row>
          <b-col md="6" >
            <label class="float-left" for>
              <input
                type="radio"
                v-model="$v.diagnosedGestationalDiabetes.$model"
                class="option-input radio"
                :class="{ 'invalid-radio-button': gestationalDiabetesState }"
                name="rd3"
                :value="true"
              >
              Yes
            </label>
          </b-col>
          <b-col md="6" >
            <label class="float-left" for>
              <input
                type="radio"
                v-model="$v.diagnosedGestationalDiabetes.$model"
                class="option-input radio"
                :class="{ 'invalid-radio-button': gestationalDiabetesState }"
                name="rd3"
                :value="false"
              >
              No
            </label>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <hr v-show="gender != null && gender == 'F'">
    <b-row>
      <b-col sm="8" class="row-align-left">
        <label for="radios3">
          Do you have a mother, father, sister, or brother with
          diabetes?
        </label>
      </b-col>
      <b-col sm="4">
        <b-row>
          <b-col md="6" >
            <label class="float-left" for>
              <input
                type="radio"
                v-model="$v.relativeWithDiabetes.$model"
                class="option-input radio"
                :class="{ 'invalid-radio-button': relativeState }"
                name="rd4"
                :value="true"
              >
              Yes
            </label>
          </b-col>
          <b-col md="6" >
            <label class="float-left" for>
              <input
                type="radio"
                v-model="$v.relativeWithDiabetes.$model"
                class="option-input radio"
                :class="{ 'invalid-radio-button': relativeState }"
                name="rd4"
                :value="false"
              >
              No
            </label>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <hr>
    <survey-nav :step="1" :ShowErrorMsg="showErrorMsg" @move-next="moveNext" @move-previous="movePrevious"></survey-nav>
  </div>
</template>
<script>
import { required, maxLength } from "vuelidate/lib/validators";
import surveyNav from "@/components/SurveyNav";

export default {
  name: "survey-step1",
  props: ["surveyData", "isValid"],
  data: () => ({
    selected: null,
    //isValid: false,
    age: null,
    diagnosedDiabetes: null,
    diagnosedGestationalDiabetes: null,
    gender: null,
    relativeWithDiabetes: null,
    showErrorMsg: false
  }),
  validations: {
    age: {
      required,
      maxLength: maxLength(200)
    },
    diagnosedDiabetes: {
      required
    },
    gender: {
      required
    },
    diagnosedGestationalDiabetes: {
      required
    },
    relativeWithDiabetes: {
      required
    }
  },
  components: {
    surveyNav
  },
  methods: {
    moveNext() {
      if (!this.$v.$invalid) this.$emit("move-next");
      else{
        this.showErrorMsg = true;
        this.$v.$touch();
      } 
    },
    movePrevious() {},
    onCreated() {
      //load the data from the survey into the form
      this.age = this.surveyData.Age;
      this.diagnosedDiabetes = this.surveyData.DiagnosedDiabetes;
      this.diagnosedGestationalDiabetes = this.surveyData.DiagnosedGestationalDiabetes;
      this.relativeWithDiabetes = this.surveyData.RelativeWithDiabetes;
      this.gender = this.surveyData.Gender;
    }
  },
  computed: {
    //Radio buttons must return a !result
    diabetesState () {
      return this.$v.diagnosedDiabetes.$dirty ? !this.$v.diagnosedDiabetes.required : null;  
    },
    gestationalDiabetesState () {
      return this.$v.diagnosedGestationalDiabetes.$dirty ? !this.$v.diagnosedGestationalDiabetes.required : null;  
    },
    genderState () {
      return this.$v.gender.$dirty ? !this.$v.gender.required : null;  
    },
    relativeState () {
      return this.$v.relativeWithDiabetes.$dirty ? !this.$v.relativeWithDiabetes.required : null;  
    },
    ageState () {
      return this.$v.age.$dirty ? this.$v.age.required : null;
    }
  },
  watch: {
    age() {
      console.log("inside Age function");
      if (this.$v.age.required) this.surveyData.Age = this.age;
    },
    diagnosedDiabetes() {
      if (this.$v.diagnosedDiabetes.required)
        this.surveyData.DiagnosedDiabetes = this.diagnosedDiabetes;
    },
    diagnosedGestationalDiabetes() {
      if (this.$v.diagnosedGestationalDiabetes.required) {
        this.surveyData.DiagnosedGestationalDiabetes = this.diagnosedGestationalDiabetes;
      }
    },
    gender() {
      if (this.$v.gender.required) {
        this.surveyData.Gender = this.gender;
        if (this.gender === "M" || this.gender == "X") {
          this.diagnosedGestationalDiabetes = false;
        }
      }
    },
    relativeWithDiabetes() {
      if (this.$v.relativeWithDiabetes.required)
        this.surveyData.RelativeWithDiabetes = this.relativeWithDiabetes;
    }
  },
  created() {
    this.onCreated();
  }
};
</script>

<style scoped>
.invalid-radio-button{
  background-color: red;
}
</style>
